const bindings = new WeakMap();

export function formatAddToCartText(label, price) {
  const normalizedLabel = String(label || "").trim();
  const normalizedPrice = String(price || "").trim();
  return [normalizedLabel, normalizedPrice].filter(Boolean).join(" ");
}

export function bindAddToCartPrice(root, t) {
  const button = root.querySelector(".js-save-poster");
  const subtotal = root.querySelector(".subtotal");
  if (!button || !subtotal || bindings.has(button)) return;

  const label = t("actions.addToCart");
  let updating = false;

  const update = () => {
    if (updating || button.disabled) return;

    const currentText = button.textContent.trim();
    if (currentText !== label && !currentText.startsWith(`${label} `)) return;

    const nextText = formatAddToCartText(label, subtotal.textContent);
    if (!nextText || currentText === nextText) return;

    updating = true;
    button.textContent = nextText;
    updating = false;
  };

  const observer = new MutationObserver(update);
  observer.observe(button, {
    attributes: true,
    attributeFilter: ["disabled"],
    childList: true,
    subtree: true,
    characterData: true,
  });
  observer.observe(subtotal, {
    childList: true,
    subtree: true,
    characterData: true,
  });

  bindings.set(button, observer);
  update();
}
